/**
 * 作品案例列表
 * @author wangyichen
 * @since 18/08/06
 */

import ACTIONS from 'constants/action.json5';
import { getSearchList as getSearchListApi } from 'api/case';

/**
 * 获取搜索结果列表
 *
 * @export
 * @param {*} opts
 * @returns
 */
export function getSearchList() {
  return async (dispatch, getState) => {
    function getListSucceed(id, list, total) {
      dispatch({
        type: ACTIONS.GET_CASE_SUCCEED,
        payload: {
          id,
          list,
          total,
        },
      });
    }
    try {
      // 请求中...
      dispatch({
        type: ACTIONS.GET_CASE_ING,
      });
      // 当前页码
      const curPageNo = getState().searchList.id;
      // 下一页页码
      const nextPageNo = curPageNo + 1;
      // 获取数据
      const opts = {
        pageSize: 45,
        pageNo: nextPageNo, // 从搜索结果列表中获取+1，避免服务端渲染之后又从第1页开始渲染
        keyword: getState().caseKeyword.keyword, // 从状态中获取关键词
      };
      const data = await getSearchListApi(opts);
      const { list, total } = data;
      // 没有数据
      if (!total) {
        // 第1页就没有数据表示该分类下无数据
        getListSucceed(curPageNo, [], 0);
        return;
      } else {
        if (!list.length) {
          // 后面页没有数据表示该分类的数据已加载完
          dispatch({
            type: ACTIONS.GET_CASE_ENDED,
          });
          return;
        }
      }
      // 正常获取到数据
      getListSucceed(nextPageNo, list, total);
    } catch (e) {
      console.error(e);
      // 请求出错
      dispatch({
        type: ACTIONS.GET_CASE_FAILED,
      });
    }
  };
}
